import { render, staticRenderFns } from "./ProductizeModelPage.vue?vue&type=template&id=61ddb1e3&scoped=true"
import script from "./ProductizeModelPage.vue?vue&type=script&lang=js"
export * from "./ProductizeModelPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ddb1e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ddb1e3')) {
      api.createRecord('61ddb1e3', component.options)
    } else {
      api.reload('61ddb1e3', component.options)
    }
    module.hot.accept("./ProductizeModelPage.vue?vue&type=template&id=61ddb1e3&scoped=true", function () {
      api.rerender('61ddb1e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/ProductizeModelPage.vue"
export default component.exports